import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppWidget from './components/WhatsAppWidget';
import { Toaster } from './components/ui/sonner';

// Pages
import Home from './pages/Home';
import Records from './pages/Records';
import GuinnessRecords from './pages/GuinnessRecords';
import WorldBookRecords from './pages/WorldBookRecords';
import IndiaBookRecords from './pages/IndiaBookRecords';
import AsiaBookRecords from './pages/AsiaBookRecords';
import Books from './pages/Books';
import PublishedBooks from './pages/PublishedBooks';
import UpcomingBooks from './pages/UpcomingBooks';
import SubmitChapter from './pages/SubmitChapter';
import PublishBook from './pages/PublishBook';
import Conference from './pages/Conference';
import PastConference from './pages/PastConference';
import UpcomingConference from './pages/UpcomingConference';
import Awards from './pages/Awards';
import PastAwards from './pages/PastAwards';
import UpcomingAwards from './pages/UpcomingAwards';
import AwardDetails from './pages/AwardDetails';
import AwardNomination from './pages/AwardNomination';
import AwardForm from './pages/AwardForm';
import Events from './pages/Events';
import EventRegistration from './pages/EventRegistration';
import Authors from './pages/Authors';
import Legends from './pages/Legends';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import About from './pages/About';
import ThankYou from './pages/ThankYou';
import Admin from './pages/Admin';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            
            <Route path="/" element={<Home />} />
            <Route path="/records" element={<Records />} />
            <Route path="/records/guinness" element={<GuinnessRecords />} />
            <Route path="/records/world-book" element={<WorldBookRecords />} />
            <Route path="/records/india-book" element={<IndiaBookRecords />} />
            <Route path="/records/asia-book" element={<AsiaBookRecords />} />
            <Route path="/books" element={<Books />} />
            <Route path="/books/published" element={<PublishedBooks />} />
            <Route path="/books/upcoming" element={<UpcomingBooks />} />
            <Route path="/books/submit-chapter" element={<SubmitChapter />} />
            <Route path="/books/publish" element={<PublishBook />} />
            <Route path="/conference" element={<Conference />} />
            <Route path="/conference/past" element={<PastConference />} />
            <Route path="/conference/upcoming" element={<UpcomingConference />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/awards/past" element={<PastAwards />} />
            <Route path="/awards/upcoming" element={<UpcomingAwards />} />
            <Route path="/awards/details/:id" element={<AwardDetails />} />
            <Route path="/awards/nomination/:categoryIds" element={<AwardNomination />} />
            <Route path="/awards/form/:categoryId" element={<AwardForm />} />
            <Route path="/events" element={<Events />} />
            <Route path="/event-registration/:eventId" element={<EventRegistration />} />
            <Route path="/authors" element={<Authors />} />
            <Route path="/legends" element={<Legends />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/about" element={<About />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppWidget />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;